var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForcePlateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_1268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.73717 5.09994C9.41086 5.68562 9.13646 6.19524 9.12163 6.23327C9.1068 6.27131 9.25512 6.30934 9.45535 6.32455L9.81133 6.34737L9.83358 8.60644L9.84841 10.8731H10.4046H10.9608V8.59883V6.31694L11.3242 6.29412L11.6876 6.27131L11.0721 5.16839C10.7309 4.5675 10.4269 4.05788 10.3898 4.05027C10.3601 4.04266 10.0635 4.51425 9.73717 5.09994Z",
    fill: "#4D5874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.28907 12.4404C1.20007 12.524 1.17041 12.7142 1.17041 13.1554C1.17041 13.6878 1.18524 13.7715 1.33356 13.8704C1.58571 14.0529 19.1471 14.0529 19.3993 13.8704C19.5476 13.7715 19.5624 13.6878 19.5624 13.1554C19.5624 12.7142 19.5327 12.524 19.4437 12.4404C19.3399 12.3339 18.4129 12.3187 10.3664 12.3187C2.31991 12.3187 1.39289 12.3339 1.28907 12.4404Z",
    fill: "#4D5874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09018 14.4024C2.06793 14.4557 2.06051 14.6534 2.07534 14.836L2.09759 15.1707H3.02461H3.95162V14.7523V14.334L3.03944 14.3111C2.31266 14.2959 2.12726 14.3111 2.09018 14.4024Z",
    fill: "#4D5874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7752 14.4024C16.753 14.4557 16.7456 14.6534 16.7604 14.836L16.7827 15.1707H17.7097H18.6367V14.7523V14.334L17.7245 14.3111C16.9977 14.2959 16.8123 14.3111 16.7752 14.4024Z",
    fill: "#4D5874"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_1268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    fill: "white",
    transform: "translate(1 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForcePlateIcon);
export default __webpack_public_path__ + "static/media/force_plate_icon.c00092159ec483a7b4df310a0d8e6bef.svg";
export { ForwardRef as ReactComponent };